import type { PaymentOrder } from '../types';
import { BANKS, buildVietQrUrl } from './vietqr';

export function canRegeneratePaymentQr(order: PaymentOrder) {
  return validatePaymentOrderForQr(order, ['approved']) === null;
}

export function validatePaymentOrderForQr(
  order: PaymentOrder,
  allowedStatuses: PaymentOrder['status'][] = ['pending'],
): string | null {
  if (!allowedStatuses.includes(order.status)) return 'Trạng thái lệnh không cho phép tạo VietQR.';
  if (!BANKS.some((bank) => bank.bin === order.bankBin)) return 'BIN ngân hàng không thuộc danh mục VietQR hợp lệ.';
  if (!String(order.accountNumber || '').trim()) return 'Thiếu số tài khoản.';
  if (!String(order.accountHolder || '').trim()) return 'Thiếu chủ tài khoản.';
  if (!Number.isFinite(Number(order.amount)) || Number(order.amount) <= 0) return 'Số tiền phải lớn hơn 0.';
  if (!String(order.addInfo || '').trim()) return 'Thiếu nội dung chuyển khoản.';
  return null;
}

export function buildApprovedPaymentOrder(order: PaymentOrder): PaymentOrder {
  const error = validatePaymentOrderForQr(order, ['pending']);
  if (error) throw new Error(error);
  const vietQrUrl = buildVietQrUrl({
    bin: order.bankBin!,
    accountNumber: order.accountNumber!.trim(),
    amount: Number(order.amount),
    addInfo: order.addInfo!.trim(),
    accountName: order.accountHolder!.trim(),
  });
  return {
    ...order,
    status: 'approved',
    approvedAt: new Date().toISOString(),
    vietQrUrl,
  };
}

export function rebuildApprovedPaymentOrderQr(order: PaymentOrder): PaymentOrder {
  const error = validatePaymentOrderForQr(order, ['approved']);
  if (error) throw new Error(error);
  return {
    ...order,
    vietQrUrl: buildVietQrUrl({
      bin: order.bankBin!,
      accountNumber: order.accountNumber!.trim(),
      amount: Number(order.amount),
      addInfo: order.addInfo!.trim(),
      accountName: order.accountHolder!.trim(),
    }),
  };
}
